<script>

import axios from 'axios';

export default {
  name: "WaterBill",
  data() {
    return {
      accountNumber: '',
      isSearching: false,
      currentSlide: 0,
      slideInterval: null,
      slides: [
        { 
          image: require('../../assets/images/water_hero.png'), 
          title: "Safe & Secure Payments" 
        },
        { 
          image: require('../../assets/images/banner.jpg'), 
          title: "Easy Usage Tracking" 
        },
        { 
          image: require('../../assets/images/water_tap.jpg'), 
          title: "Eco Friendly Billing" 
        },
        {
          image: require('../../assets/images/water_flow.jpg'), 
          title: "Stop Water Leakage" 
        }

      ]
    };
  },
  mounted() {
    this.restoreBackendBaseUrl();
    this.startAutoSlide();
  },
  beforeUnmount() {
    this.stopAutoSlide();
  },
  methods: {
    resolveBackendBaseUrl() {
      try {
        const saved = window.sessionStorage.getItem("backendUrl");
        if (saved) return saved;
      } catch {
        // ignore session storage access errors
      }
      return `${window.location.origin}/api`;
    },
    restoreBackendBaseUrl() {
      const base = this.resolveBackendBaseUrl();
      axios.defaults.baseURL = base;
      return base;
    },
    startAutoSlide() {
      this.slideInterval = setInterval(() => { this.nextSlide(); }, 5000);
    },
    stopAutoSlide() { clearInterval(this.slideInterval); },
    nextSlide() { this.currentSlide = (this.currentSlide + 1) % this.slides.length; },
    goToSlide(index) {
      this.currentSlide = index;
      this.stopAutoSlide();
      this.startAutoSlide();
    },
    async fetchBillDetails(accountNumber) {
      const base = this.resolveBackendBaseUrl();
      const response = await axios.get(`${base}/water_bill/fetch_details`, {
        params: { accNo: accountNumber }
      });
      return response.data;
    },
    async proceedToPayment() {
    const normalizedAccountNumber = String(this.accountNumber || "").trim().toUpperCase();
    if (normalizedAccountNumber) {
      try {
        this.isSearching = true;
        this.accountNumber = normalizedAccountNumber;
        this.restoreBackendBaseUrl();
        let responseData;

        try {
          responseData = await this.fetchBillDetails(normalizedAccountNumber);
        } catch (firstError) {
          await new Promise((resolve) => setTimeout(resolve, 250));
          responseData = await this.fetchBillDetails(normalizedAccountNumber);
        }

        if (responseData.status === 'success') {
        const bill = responseData.data;
          this.$router.push({
            path: '/payment-process',
            query: { 
              accountId: bill.account_id,
              accNo: normalizedAccountNumber,
              accountNumber: bill.account_number || normalizedAccountNumber,
              customerNic: bill.customer_nic || '',
              customerName: bill.customer_name || '',
              sabhaCode: bill.sabha_code || '',
              contactNo: bill.contact_info || '',
              address: bill.mailing_address || '',
              currentBalance: bill.current_balance ?? 0,
              monthly: bill.monthly_charge,
              arrears: bill.previous_dues,
              billId: bill.id,
              bDate: bill.billing_date,
              pFrom: bill.period_from,
              pTo: bill.period_to,
              pRead: bill.previous_reading,
              cRead: bill.current_reading,
              units: bill.units_consumed
            }
          });
        }
      } catch (error) {
        console.error("Error fetching bill:", error);
        alert("බිල්පත් අංකය වැරදියි හෝ දත්ත සොයාගත නොහැක.");
      } finally {
        this.isSearching = false;
      }
    } else {
      alert("Please enter a valid Account Number!");
    }
  }
  }
};
</script>

<template>
  <div class="water-bill-page">
    <div class="bg-slider">
      <transition-group name="fade">
        <div 
          v-for="(slide, index) in slides" 
          :key="index"
          v-show="currentSlide === index"
          class="bg-slide"
          :style="{ backgroundImage: 'url(' + slide.image + ')' }"
        ></div>
      </transition-group>
      <div class="bg-overlay"></div>
    </div>

    <section class="hero-section">
      <div class="container d-flex justify-content-center">
        
        <div class="payment-card animate__animated animate__zoomIn">
          <div class="text-center mb-2">
            <span class="badge-text" >Water Bill Payment</span>
          </div>

          <h1 class="main-title text-center">Pay Your Bill <span class="highlight">Online</span></h1>

          <form @submit.prevent="proceedToPayment" class="mt-5">
            <div class="form-group mb-5">
              <div class="d-flex justify-content-center align-items-center mb-3">
                <label class="form-label">Water Bill Number</label>
              </div>
              <i class="fas fa-user-circle user-icon-top"></i>
              
              <div class="input-container">
                <input 
                  type="text" 
                  v-model="accountNumber" 
                  placeholder="Ex: 000MATDSM001" 
                  class="custom-input"
                  required
                  autofocus
                >
              </div>
            </div>

            <button type="submit" class="btn-submit" :disabled="isSearching">
              <span>{{ isSearching ? 'Loading Bill Details...' : 'Fetch Bill Details' }}</span>
            </button>
          </form>

          <div class="secure-footer mt-5 text-center">
            <p class="secure-label">SECURED BY</p>
            <div class="payment-brand-row">
              <img src="../../assets/images/visa-logo-png-2017.png" alt="Visa" class="brand-logo">
              <img src="https://upload.wikimedia.org/wikipedia/commons/2/2a/Mastercard-logo.svg" alt="Mastercard" class="brand-logo">
              </div>
          </div>
        </div>

      </div>
    </section>
  </div>
</template>

<style scoped>
/* Main Container */
.water-bill-page {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  width: 100%;
  font-family: 'Poppins', sans-serif;
  overflow-x: hidden;
}

.hero-section {
  position: relative;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  padding-bottom: 50px;
  background: rgba(0, 0, 0, 0.5);
}

.form-group {
  text-align: center;
}
/* Background Handling */

.bg-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.bg-slide {
  position: absolute;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  transition: opacity 1.5s ease-in-out;
}

.payment-card {
  position: relative;
  z-index: 2;
  background: white;
  width: 90%;
  max-width: 450px;
  padding: 30px 45px;
  border-radius: 50px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.1);
}

.badge-text {
  font-size: 14px;
  font-weight: 600;
  color: #4a5568;
  letter-spacing: 0.5px;
}

.main-title {
  font-size: 30px;
  font-weight: 700;
  color: #1a202c;
}

.highlight {
  color: #0061ff;
}

/* Form Styling */
.form-label {
  font-size: 16px;
  color: #4a5568;
  font-weight: 500;
  margin-bottom: 10px;
}

.user-icon-top {
  font-size: 50px;
  color: #2d3748;
  margin-bottom: 10px;
}

.input-container {
  width: 100%;
}

.custom-input {
  width: 100%;
  padding: 25px;
  border-radius: 30px;
  border: 1px solid #e2e8f0;
  background: #fdfdfd;
  font-size: 16px;
  text-align: center;
  color: #1c222d;
  transition: all 0.3s ease;
}

.custom-input::placeholder {
  color: #566983;
}

.custom-input:focus {
  outline: none;
  border-color: #00d2ff;
  box-shadow: 0 0 15px rgba(0, 210, 255, 0.15);
}

/* Button Styling */
.btn-submit {
  width: 100%;
  padding: 25px;
  background: linear-gradient(to right, #0061ff, #00d2ff);
  color: white;
  border: none;
  border-radius: 30px;
  font-size: 20px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 10px 30px rgba(0, 97, 255, 0.3);
  transition: transform 0.2s ease;
}

.btn-submit:hover {
  transform: translateY(-2px);
}

/* Footer Logos */
.secure-label {
  font-size: 12px;
  font-weight: 700;
  color: #8093ad;
  letter-spacing: 1.5px;
  margin-bottom: 20px;
}

.payment-brand-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 25px;
}

.brand-logo {
  height: 40px;
  opacity: 0.8;
}

/* Animations */
.fade-enter-active, .fade-leave-active {
  transition: opacity 1.5s ease;
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
}

/* Responsive */
@media (max-width: 768px) {
  .payment-card {
    padding: 40px 25px;
    border-radius: 40px;
    margin: 20px;
  }
  .main-title {
    font-size: 36px;
  }
  .custom-input, .btn-submit {
    font-size: 16px;
    padding: 18px;
  }
}
</style>